/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Code_MissingInputs */

const cs_listing_code_missing = /** @type {(inputs: Listing_Code_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez čísla zakázky`)
};

const en_listing_code_missing = /** @type {(inputs: Listing_Code_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No listing number`)
};

/**
* | output |
* | --- |
* | "No listing number" |
*
* @param {Listing_Code_MissingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const listing_code_missing = /** @type {((inputs?: Listing_Code_MissingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Code_MissingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_code_missing(inputs)
	return cs_listing_code_missing(inputs)
});